var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDzen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_280_547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 54V18C0 8.1 8.1 0 18 0H54C63.9 0 72 8.1 72 18V54C72 63.9 63.9 72 54 72H18C8.1 72 0 63.9 0 54Z",
    fill: "#0C0C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 35.0356C59 34.8007 58.8091 34.6061 58.5741 34.5951C50.1424 34.2757 45.0108 33.2001 41.4208 29.6099C37.8235 26.0123 36.7517 20.8765 36.4323 12.4258C36.425 12.1909 36.2304 12 35.9918 12H35.0081C34.7731 12 34.5786 12.1909 34.5676 12.4258C34.2482 20.8728 33.1764 26.0123 29.5791 29.6099C25.9854 33.2038 20.8574 34.2757 12.4258 34.5951C12.1909 34.6024 12 34.797 12 35.0356V36.0195C12 36.2544 12.1909 36.449 12.4258 36.46C20.8574 36.7794 25.9891 37.855 29.5791 41.4452C33.169 45.0355 34.2409 50.1567 34.5639 58.574C34.5713 58.809 34.7658 59 35.0044 59H35.9918C36.2268 59 36.4213 58.809 36.4323 58.574C36.7553 50.1567 37.8272 45.0355 41.4171 41.4452C45.0108 37.8513 50.1387 36.7794 58.5704 36.46C58.8054 36.4526 58.9963 36.2581 58.9963 36.0195V35.0356H59Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDzen);
export default __webpack_public_path__ + "static/media/dzen.a67560a91fe7de3488820022b6e49cf6.svg";
export { ForwardRef as ReactComponent };